export const SHOPIFY_EXPRESS_LIBRARY_VERSION = '6.0.4';
